module.exports = __webpack_public_path__ + "img/logo-weicaishui.aee4a865.png";